<template>
  <base-modal @close="close">
    <template #heading>
      Help Video
    </template>
    <div class="content">
      <div class="iframe_wrap">
        <iframe
          id="vimeo-player"
          allow="autoplay; fullscreen"
          allowfullscreen=""
          height="450"
          src="https://player.vimeo.com/video/400958980?color=fa625a&amp;title=0&amp;byline=0&amp;portrait=0"
          width="800"
        />
      </div>

      <primary-button
        class="close_modal"
        size="md"
        @click="close"
      >
        I've finished watching the video
      </primary-button>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from "../../../global/modals/BaseModal";
import PrimaryButton from "../../../global/buttons/PrimaryButton";

export default {
  components: {
    PrimaryButton,
    BaseModal
  },
  emits: ['close'],
  mounted() {
    window.mixpanel('Sitewide: Watch Help Video', {
      page_url: window.location.href,
    })
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.iframe_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
}

.close_modal {
  width: 270px;
  margin-left: auto;
}
</style>
